import { Modal } from "../../utils/Modal";

/**
 * entity-picker — 버튼 클릭 시 모달로 단일 선택 피커를 띄운다.
 *
 * entity-picker.php 가 렌더한 [data-entity-picker] 버튼 클릭 시, 같은 루트의
 * [data-entity-picker-template](서버 렌더 = 신뢰 HTML)을 Modal.content() 로 띄우고,
 * 모달 본문에서 검색 필터(client-side) + 카드 클릭 시 data-picker-href 로 이동한다.
 *
 * 인라인 스크립트·raw select 를 대체 (#2 Modal 유틸만 / #1 / #19). AdminLayout.init() 에서 1회 호출.
 */
export function initAdminEntityPicker(root: ParentNode = document): void {
  const triggers = (root as Element | Document).querySelectorAll<HTMLElement>(
    "[data-entity-picker]:not([data-entity-picker-inited])",
  );
  triggers.forEach((trigger) => {
    trigger.dataset.entityPickerInited = "1";
    trigger.addEventListener("click", () => openPicker(trigger));
  });
}

function findTemplate(trigger: HTMLElement): HTMLTemplateElement | null {
  const scope = trigger.closest("[data-entity-picker-root]") ?? trigger.parentElement;
  return scope?.querySelector<HTMLTemplateElement>("[data-entity-picker-template]") ?? null;
}

function openPicker(trigger: HTMLElement): void {
  const template = findTemplate(trigger);
  if (!template) return;

  const title = trigger.getAttribute("data-picker-title") ?? "선택";
  Modal.content(template.innerHTML, title, "md").catch(() => {});

  // Modal.content 는 즉시 DOM 에 append → 본문 바인딩.
  const panel = document.querySelector<HTMLElement>(
    ".app-modal-body .admin-entity-picker__panel",
  );
  if (!panel) return;
  bind(panel);
}

function bind(panel: HTMLElement): void {
  const search = panel.querySelector<HTMLInputElement>("[data-picker-search]");
  const items = Array.from(panel.querySelectorAll<HTMLElement>("[data-picker-item]"));
  const noResult = panel.querySelector<HTMLElement>("[data-picker-no-result]");

  // 카드 클릭 → 이동
  items.forEach((item) => {
    item.addEventListener("click", () => {
      const href = item.getAttribute("data-picker-href");
      if (href) window.location.href = href;
    });
  });

  // 검색 필터 (client-side)
  if (search) {
    const apply = (): void => {
      const q = search.value.trim().toLowerCase();
      let visible = 0;
      items.forEach((item) => {
        const text = item.getAttribute("data-picker-search-text") ?? "";
        const match = q === "" || text.includes(q);
        const li = item.closest("li") ?? item;
        li.toggleAttribute("hidden", !match);
        if (match) visible++;
      });
      if (noResult) noResult.toggleAttribute("hidden", visible !== 0);
    };
    search.addEventListener("input", apply);
    // 모달 오픈 직후 검색창 포커스
    window.setTimeout(() => search.focus(), 50);
  }
}
